import { option } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { errorConstants, getErrorCodeForKey, TError } from "../../../../../shared/src/codecs/errors";

export const slugErrorMessage = (validationErrors: TError): string | null =>
    pipe(
        getErrorCodeForKey("edited.slug", validationErrors),
        option.fold(
            (): string | null => null,
            (code) => {
                switch (code) {
                    case errorConstants.NOT_UNIQUE:
                        return "Another introducer already uses this slug.";
                    case errorConstants.IN_USE:
                        return "The portal already uses this word for one of its own pages. Pick another one.";
                    default:
                        return "Use lowercase letters, numbers and hyphens. For example: estate-search.";
                }
            },
        ),
    );
